import { render, staticRenderFns } from "./AllTransactions.vue?vue&type=template&id=7285515c"
import script from "./AllTransactions.vue?vue&type=script&lang=js"
export * from "./AllTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports